import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';
import { FaSave, FaTimes, FaCheckCircle } from 'react-icons/fa';
import { Alertassw } from '../Alertas/Alertassw';
import { filterData } from '../../api/common';
import SelectorCuentaExterna from './SelectorCuentaExterna';
import SelectorCuentaBanco from './SelectorCuentaBanco';

const CLASES = [  // que tenga value y label igual para facilitar el select, y que el value sea exactamente igual al enum del backend para no tener que mapear al guardar.
  { value: 1 , label: 'Activo' },
  { value: 2, label: 'Pasivo' },
  { value: 3, label: 'Patrimonio' },
  { value: 4, label: 'Ingresos' },
  { value: 5, label: 'Gastos' },
  { value: 6, label: 'Costos de venta' },
  { value: 7, label: 'Costos de producción o de operación' },
  { value: 8, label: 'Cuentas de orden deudoras' },
  { value: 9, label: 'Cuentas de orden acreedoras' },
];

const NATURALEZA = ['Débito', 'Crédito'];

const DEFAULT_FORM = {
  codigo: '',
  clase: '',
  nombre: '',
  categoria: '',
  subcategoria: [],
  nivel: 1,
  naturaleza: 'Débito',
  descripcion: '',
  activo: true,
  requiere_tercero: false,
  requiere_centro_costo: false
};

const CuentasContablesForm = ({ show, onHide, onSuccess, initialData = null, collection = 'CuentasContables' }) => {
  const [form, setForm] = useState({ ...DEFAULT_FORM });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [subcategoriaText, setSubcategoriaText] = useState('');
  const [responsables, setResponsables] = useState([]);
  const [cuentaImportada, setCuentaImportada] = useState(null);
  const [esCuentaBanco, setEsCuentaBanco] = useState(false);
  const [cuentaBancoSeleccionada, setCuentaBancoSeleccionada] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({ ...DEFAULT_FORM, ...initialData, subcategoria: initialData.subcategoria || [] });
      setSubcategoriaText((initialData.subcategoria || []).join(', '));
    } else {
      setForm({ ...DEFAULT_FORM });
      setSubcategoriaText('');
    }
    setCuentaImportada(null);
    setEsCuentaBanco(!!initialData?.bankId);
    setCuentaBancoSeleccionada(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData, show]);

  // Prerellena el form cuando el usuario selecciona una cuenta del proveedor.
  // No guarda nada en el backend — el guardado sigue ocurriendo via handleSubmit
  // y el usuario puede editar los campos antes.
  const handleImportarExterna = (cuentaExterna) => {

    console.log('Cuenta externa seleccionada para importar:', cuentaExterna);

    if (!cuentaExterna) return;
    setForm(prev => ({
      ...prev,
      codigo: cuentaExterna.codigo || prev.codigo,
      nombre: cuentaExterna.nombre || prev.nombre,
      clase: cuentaExterna.clase || (cuentaExterna.codigo ? cuentaExterna.codigo.toString().charAt(0) : prev.clase),  //primer digito del codigo o clase completa si viene así
      naturaleza: cuentaExterna.naturaleza || prev.naturaleza,
      descripcion: cuentaExterna.descripcion || prev.descripcion,
      idContable: cuentaExterna.idContable || prev.idContable
    }));
    setCuentaImportada(cuentaExterna);
    setErrors({});
  };

  const handleToggleEsCuentaBanco = (e) => {
    const checked = e.target.checked;
    setEsCuentaBanco(checked);
    if (!checked) {
      setCuentaBancoSeleccionada(null);
      setForm(prev => ({ ...prev, bankId: null }));
    }
  };

  const handleSelectCuentaBanco = (cuentaBanco) => {
    setCuentaBancoSeleccionada(cuentaBanco);
    setForm(prev => ({ ...prev, bankId: cuentaBanco ? cuentaBanco.id : null }));
  };

    async function ConsultUserSistem() {
               const clientesDB = await filterData("usuarios",[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
                    {
                        "$match": {
                        'status': 'activo'
                        } 
                    },
                    {
                        "$lookup": {
                        "from": "roles",
                        "localField": "role",
                        "foreignField": "_id",
                        "as": "result"
                        }
                    },
                    {
                        "$match": {
                        "result.nombre": { $ne: "Cliente" } 
                        }
                    }
                    ]);
            
                      const cl = clientesDB.data.data.map((client)=>({
                      value:client._id,
                      label:client.nombre + " "+ client.apellido ,
                  }));
                  setResponsables(cl)
  }

  useEffect(() => {
    // calcular nivel según la longitud del codigo (imitando lógica en backend)
    const computeNivel = (codigo) => {
      if (!codigo) return 1;
      const len = codigo.toString().trim().length;
      if (len === 1) return 1;
      if (len === 2) return 2;
      if (len === 4) return 3;
      if (len === 6) return 4;
      if (len === 8) return 5;
      return Math.min(7, len);
    };
    setForm(prev => ({ ...prev, nivel: computeNivel(prev.codigo) }));
    ConsultUserSistem()

  }, [form.codigo]);

  const handleChange = (e) => {
    
    const { name, value, type, checked } = e.target;
    const v = type === 'checkbox' ? checked : value;
    // esFuenteFondos y esBolsilloPersonal son mutuamente excluyentes: al marcar
    // uno se desmarca el otro y el body que se envía nunca lleva ambos en true.

    if (name === 'esFuenteFondos' || name === 'esBolsilloPersonal') {
      const otro = name === 'esFuenteFondos' ? 'esBolsilloPersonal' : 'esFuenteFondos';

      // si es esBolsilloPersonal y se marca, 
      // entonces requiere_tercero se marca también 
      // (porque una cuenta de bolsillo personal siempre requiere tercero), y si se desmarca, entonces se desmarca también requiere_tercero (porque si no es bolsillo personal, entonces no es obligatorio que requiera tercero).
      
      if (name === 'esBolsilloPersonal') {
        console.log(`Toggle ${name}:`, v, ` - marcando requiere_tercero`);
        setForm(prev => ({
          ...prev,
          [name]: v,
          requiere_tercero: v, // si se marca esBolsilloPersonal, entonces requiere_tercero se marca también, pero si se desmarca esBolsilloPersonal, entonces no se desmarca automáticamente requiere_tercero porque podría ser que el usuario quiera dejar la cuenta sin ser bolsillo personal pero que siga requiriendo tercero.
          [otro]: false
        }));
      } else {
        console.log(`Toggle ${name}:`, v, ` - desmarcando ${otro} si estaba marcado`);
        setForm(prev => ({
          ...prev,
          [name]: v,
          requiere_tercero: false, // si se marca esBolsilloPersonal, entonces requiere_tercero se marca también, pero si se desmarca esBolsilloPersonal, entonces no se desmarca automáticamente requiere_tercero porque podría ser que el usuario quiera dejar la cuenta sin ser bolsillo personal pero que siga requiriendo tercero.
          [otro]: v ? false : prev[otro]
        }));
      }
      if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
      if (errors[otro]) setErrors(prev => ({ ...prev, [otro]: '' }));
      return;
    }

    setForm(prev => ({ ...prev, [name]: v }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubcategoriaChange = (e) => {
    setSubcategoriaText(e.target.value);
  };

  const parseSubcategoria = (text) => {
    const arr = (text || '').split(',').map(s => s.trim()).filter(Boolean);
    setForm(prev => ({ ...prev, subcategoria: arr }));
  };

  const validate = () => {
    const err = {};
    if (!form.codigo || !form.codigo.toString().trim()) err.codigo = 'Código es requerido';
    if (!form.clase) err.clase = 'Clase es requerida';
    if (!form.nombre || !form.nombre.trim()) err.nombre = 'Nombre es requerido';
      if (form.clase === '5') {
        if (!form.categoria || !form.categoria.trim()) err.categoria = 'Categoría es requerida';
        if (!form.subcategoria || form.subcategoria.length === 0) err.subcategoria = 'Al menos una subcategoría es requerida';
    }
    if (form.esBolsilloPersonal && form.esFuenteFondos) err.esFuenteFondos = 'Una cuenta no puede ser fuente de fondos y bolsillo personal al mismo tiempo';
    if (form.esBolsilloPersonal && !form.requiere_tercero) err.requiere_tercero = 'Si la cuenta es bolsillo personal, debe requerir tercero';
    if (!form.naturaleza) err.naturaleza = 'Naturaleza es requerida';
      if (form.clase === '1' && !form.esFuenteFondos && !form.esBolsilloPersonal) err.esFuenteFondos = 'Para clase Activo, la cuenta debe ser fuente de fondos o bolsillo personal';
    if (form.requiere_tercero && !form.responsable) err.responsable = 'Responsable requerido'
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // ensure subcategoria is parsed from text before validating/sending
    parseSubcategoria(subcategoriaText);
    if (!validate()) return;
    setSaving(true);

    try {
      // delegate API calls to parent via onSuccess (parent will create or update)
      if (onSuccess) {
        const payload = { ...form };
        if (!initialData) delete payload._id;
        await onSuccess(payload);
      }
      Alertassw('success', 'Guardado', 'Cuenta contable guardada correctamente');
      onHide();
    } catch (err) {
      console.error(err);
      Alertassw('error', 'Error', err?.message || 'Error guardando cuenta');
    } finally {
      setSaving(false);
    }
  };

  const subcategoriaValue = subcategoriaText || (form.subcategoria || []).join(', ');

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      fullscreen="md-down"
      scrollable
      dialogClassName="cuenta-form-modal-dialog"
    >
      {/* Modal a 90% de la altura de la ventana en desktop;
          fullscreen automatico en pantallas <md (movil). */}
      <style>{`
        .cuenta-form-modal-dialog .modal-content {
          height: 90vh;
          max-height: 90vh;
        }
        @media (max-width: 767.98px) {
          .cuenta-form-modal-dialog .modal-content {
            height: 100vh;
            max-height: 100vh;
          }
        }
      `}</style>
      <Form onSubmit={handleSubmit} className="d-flex flex-column" style={{ flex: 1, minHeight: 0 }}>
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #198754 0%, #146c43 100%)' }}>
          <Modal.Title className="text-white">{initialData ? 'Editar Cuenta Contable' : 'Crear Cuenta Contable'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowY: 'auto' }}>
          <div className="mb-3 p-3 border rounded bg-light">
            <SelectorCuentaExterna onSelect={handleImportarExterna} />

            {(cuentaImportada || form.idContable) && (
              <Alert variant="success" className="py-2 small mt-2 mb-2 d-flex align-items-center">
                <FaCheckCircle className="me-2" />
                {cuentaImportada ? (
                  <span>
                    Datos importados de <strong className="mx-1">{cuentaImportada.nombre}</strong>
                    (codigo {cuentaImportada.codigo}). Edita lo que necesites antes de guardar.
                  </span>
                ) : (
                  <span>
                    Sincronizada con el proveedor — idContable: <strong className="mx-1">{form.idContable}</strong>.
                    Puedes seleccionar otra arriba para reemplazar.
                  </span>
                )}
              </Alert>
            )}

            {/*(cuentaImportada || form.idContable) && (
              <>
                <Form.Check
                  type="checkbox"
                  id="chk-es-cuenta-banco"
                  label="¿Es cuenta banco?"
                  checked={esCuentaBanco}
                  onChange={handleToggleEsCuentaBanco}
                />
                <small className="text-muted d-block mb-2">
                  Marca esta opción si esta cuenta contable corresponde a una cuenta-banco del proveedor.
                </small>

                {esCuentaBanco && (
                  <div className="mt-2 p-2 border rounded bg-white">
                    <SelectorCuentaBanco
                      value={form.bankId}
                      onSelect={handleSelectCuentaBanco}
                    />
                    {form.bankId && (
                      <Alert variant="success" className="py-2 small mt-2 mb-0 d-flex align-items-center">
                        <FaCheckCircle className="me-2" />
                        {cuentaBancoSeleccionada ? (
                          <span>
                            Relacionada con <strong className="mx-1">{cuentaBancoSeleccionada.name}</strong>
                            (bankId {cuentaBancoSeleccionada.id}).
                          </span>
                        ) : (
                          <span>
                            Sincronizada con cuenta-banco — bankId: <strong className="mx-1">{form.bankId}</strong>.
                            Puedes seleccionar otra arriba para cambiar.
                          </span>
                        )}
                      </Alert>
                    )}
                  </div>
                )}
              </>
            )*/}
          </div>

          <Row className="g-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label className="fw-bold">Código *</Form.Label>
                <Form.Control name="codigo" value={form.codigo} onChange={handleChange} maxLength={8} />
                {errors.codigo && <div className="text-danger small">{errors.codigo}</div>}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="fw-bold">Clase *</Form.Label>
                <Form.Select name="clase" value={form.clase} onChange={handleChange}>
                  <option value="">Seleccione</option>
                  {CLASES.map(c => <option key={c.value} value={c.value}>{c.value} - {c.label}</option>)}
                </Form.Select>
                {errors.clase && <div className="text-danger small">{errors.clase}</div>}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="fw-bold">Nivel</Form.Label> {/* Se calcula automáticamente según la longitud del código se toma el primer digito*/}
                <Form.Control value={form.nivel} readOnly />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label className="fw-bold">Nombre *</Form.Label>
                <Form.Control name="nombre" value={form.nombre} onChange={handleChange} />
                {errors.nombre && <div className="text-danger small">{errors.nombre}</div>}
              </Form.Group>
            </Col>

            {/* Categoria y subcategoria son visibles y obligatorias si la clase es 5 */}
            {form.clase === '5' && (
              <>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Categoría *</Form.Label>
                    <Form.Control name="categoria" value={form.categoria} onChange={handleChange} />
                    {errors.categoria && <div className="text-danger small">{errors.categoria}</div>}
                  </Form.Group>
                </Col>

                <Col md={8}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Subcategorías (separadas por coma) *</Form.Label>
                    <Form.Control value={subcategoriaValue} onChange={handleSubcategoriaChange} onBlur={() => parseSubcategoria(subcategoriaText)} />
                    {errors.subcategoria && <div className="text-danger small">{errors.subcategoria}</div>}
                  </Form.Group>
                </Col>
              </>
            )}


            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-bold">Naturaleza *</Form.Label>
                <Form.Select name="naturaleza" value={form.naturaleza} onChange={handleChange}>
                  {NATURALEZA.map(n => <option key={n} value={n}>{n}</option>)}
                </Form.Select>
                {errors.naturaleza && <div className="text-danger small">{errors.naturaleza}</div>}
              </Form.Group>
            </Col>

            
            {/* los checkboxes de activo, requiere tercero,  y es fuente de fondos son visibles si la clase es 1*/}
            {form.clase === '1' && (
              <>
                <Col md={3} className="d-flex align-items-center">
                  <div className="w-100">
                    <Form.Check type="checkbox" label="Activo" name="activo" checked={!!form.activo} onChange={handleChange} />
                    <Form.Check type="checkbox" label="Requiere tercero" name="requiere_tercero" checked={!!form.requiere_tercero} onChange={handleChange} />
                    {errors.requiere_tercero && <div className="text-danger small">{errors.requiere_tercero}</div>}
                  </div>
                </Col>

            <Col md={3} className="d-flex align-items-center">
              {/**otro check para el campo esFuenteFondos  y esBolsilloPersonal se debe seleccionar al menos uno */}
              <div className="w-100"> 
                {/**Solo se permite un solo check  */}
                <Form.Check type="checkbox" label="Es fuente de fondos" name="esFuenteFondos" checked={!!form.esFuenteFondos} onChange={handleChange} />
                <Form.Check type="checkbox" label="Es bolsillo personal" name="esBolsilloPersonal" checked={!!form.esBolsilloPersonal} onChange={handleChange} /> {/* Si se selecciona esta opcion se deshabilita el checkbox de esFuenteFondos y viceversa y se debe validar que form.requiere_tercero tambien este seleccionado */}
                {errors.esFuenteFondos && <div className="text-danger small">{errors.esFuenteFondos}</div>}
              </div>
            </Col>
              </>
            )}


            {form.requiere_tercero && 
            <Col md={12}>
              <Form.Group>
                <Form.Label className="fw-bold">Responsable *</Form.Label>
                <Form.Select
                  name="responsable"
                  value={form.responsable}
                  onChange={handleChange}
                  isInvalid={!!errors.responsable}
                >
                  <option value="">Seleccione responsable</option>
                  {responsables.map(r => (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  ))}
                </Form.Select>
                {errors.responsable && <div className="text-danger small">{errors.responsable}</div>}
              </Form.Group>
            </Col>
            }

            {/* Inputs para saldoActual, funcion, requiereOT(check) solo si clase es 1 */}
            {form.clase === '1' && (
              <>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Saldo actual</Form.Label>
                    <Form.Control name="saldoActual" type="number" value={form.saldoActual} onChange={handleChange} />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Función de la cuenta</Form.Label> 
                    {/**debe mostrar un texto de ejemplo  en el input */}
                    <Form.Control name="funcion" placeholder="Ej: Viaticos, Caja Menor" value={form.funcion} onChange={handleChange} />
                  </Form.Group>
                </Col>
                <Col md={12} className="d-flex align-items-center">
                  <div className="w-100">
                    <Form.Check type="checkbox" label="Requiere OT" name="requiereOT" checked={!!form.requiereOT} onChange={handleChange} /> {/* Colocar un text small debajo del checkbox que diga "Si esta cuenta requiere orden de trabajo, se solicitará el número de OT al registrar gastos asociados a esta cuenta" */}
                    <div className="text-small">Si esta cuenta requiere orden de trabajo, se debe relacionar una OT al registrar gastos.</div>
                  </div>
                </Col>
              </>
            )}

            <Col md={12}>
              <Form.Group>
                <Form.Label className="fw-bold">Descripción</Form.Label>
                <Form.Control as="textarea" rows={3} name="descripcion" value={form.descripcion} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={saving}><FaTimes /> Cancelar</Button>
          <Button type="submit" variant="success" disabled={saving}><FaSave /> {saving ? 'Guardando...' : 'Guardar'}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CuentasContablesForm;
